angular.module('jv.AppDetails.Controller',['jv.React.NativeEsign'])
.controller('AppDetails',['$scope', '$rootScope', '$routeParams','application', 'TemplateLoader', '$log',
    function($scope, $rootScope, $routeParams, application, TemplateLoader, $log){
        $scope.details = {};
        $scope.interviewMessages = {};
        $scope.interviews = [];
        $scope.InterviewForms = [];
        $scope.messages = [];
        $rootScope.loading = true;
        $scope.jobDetailsModal = false;
        $scope.sendMessageModal = false;
        $scope.consentDialog = {};
        $scope.consentDialog.visible = false;
        $scope.translations = window.i18n.nativeEsign;
        $scope.locale = window._jvselfUser.locale.languageTag;
        $scope.firstName = window._jvselfUser.firstName;
        $scope.lastName = window._jvselfUser.lastName;
        $scope.documentViewer = {};
        $scope.documentViewer.visible = false;
        $scope.documentViewer.document = {};
        $scope.documentViewer.document.status = null;
        $scope.documentViewer.document.type = null;
        $scope.documentViewer.document.file = null;

        const DOCUMENT_STATUS_PENDING = 'PENDING';
        const DOCUMENT_STATUS_COMPLETED = 'COMPLETED';
        const DOCUMENT_TYPE_SIGNED = 'SIGNED';
        const DOCUMENT_TYPE_UNSIGNED = 'UNSIGNED';

        $scope.$on('hidingMessageModal', function() {
            $scope.sendMessageModal = false;
        });

        $scope.showOfferLetter = function(){
            return $scope.enableJobviteEsign && $scope.documentViewer.document.status;
        };

        $scope.templates = TemplateLoader.register({
            showDescription : '../jobseeker/jobDetails.html',
            showMessgaeModal : '../jobseeker/sendMessageModal.html'
        });

        $scope.expandMessage = function(message) {
            message.expanded = !message.expanded;
        };

        $scope.viewOfferLetter = function() {
            $scope.consentDialog.visible = true;
            if(!$scope.getConsent) {
                $scope.documentViewer.visible = true;
            }
        };

        $scope.closeOfferLetter = function() {
           $scope.documentViewer.visible = false;
           const currentURL = window.location.href;
           if(currentURL.includes('deepLink')){
               const newUrl = currentURL.split('?deepLink')[0];
               window.location = newUrl;
           }else{
               window.location.reload();
           }
       };

        $scope.onReject = function() {
            $scope.$apply(function() {
                $scope.consentDialog.visible = false;
            });
        };

        $scope.onConsent = function() {
            $rootScope.loading = true;
            application.saveNativeEsignConsent($scope.details.EId,
                function(response) {
                    $scope.consentDialog.visible = false;
                    $scope.getConsent = !response.data.success;
                    if(!$scope.getConsent) {
                        $scope.documentViewer.visible = true;
                    }
                    $rootScope.loading = false;
              }, function() {
                    $rootScope.loading = false;
              });
        };

        $scope.onSaveSignature = function(form) {
            $rootScope.loading = true;

            var formData = new FormData();
            formData.append('fullName', form.firstLastName);
            formData.append('initials', form.initials);
            formData.append('fullNameSignature', form.fullNameSignature);
            formData.append('initialsSignature', form.initialsSignature);

            var saveSignatureData = {
                appId: $scope.details.EId,
                payload: formData
            };

            return new Promise(function(resolve, reject) {
                application.saveSignature(saveSignatureData, function(res) {
                    $rootScope.loading = false;
            /*  Temporary until we can get signed document back to display
                TODO: After MVP, revisit this portion as part of the UI refactoring ticket.

                    $scope.documentViewer.document.status = 'COMPLETED';
                    $scope.documentViewer.visible = false;

                   $scope.documentViewer.document.status = res.data.status;
                    if (res.data.status === 'COMPLETED') {
                        $scope.documentViewer.visible = false;
                    }
                   resolve(res.data);
            */
              resolve(res);
                }, function(err) {
                    $log.error(err);
                    $rootScope.loading = false;
                    reject(err);
                });
            });
        };

        $scope.documentURL = '';

        $scope.showJobDescription = function() {
            $rootScope.loading = true;
            application.getJobDetails($routeParams.jobId, function(response) {
                var res = response.data;
                $scope.jobDetails = res.bean;
                $rootScope.loading = false;
                TemplateLoader.load('showDescription').then(function() {
                    $scope.jobDetailsModal = true;
                });
            }, function() {
                $rootScope.loading = false;
            });
        };

        $scope.showMessageModal = function() {
            TemplateLoader.load('showMessgaeModal').then(function() {
                $scope.sendMessageModal = true;
                $rootScope.loading = false;
            });
        };

        $scope.$on('messageSent', function(e, applicationMessage) {
            if (applicationMessage) {
                $scope.details.messages.push({
                    subject : applicationMessage.subject,
                    content : applicationMessage.content,
                    name : applicationMessage.name,
                    date : applicationMessage.date
                });
            }
        });

        $scope.hideDescriptionModal = function() {
            $scope.jobDetailsModal = false;
        };

        $scope.hideMessageModal = function() {
            $rootScope.$broadcast('hidingMessageModal');
            $scope.sendMessageModal = false;
        };

        $scope.getMilliseconds = function(dateVal){
            if(dateVal){
                var d = new Date(dateVal);
                return d.getTime();
            }
        };

        $scope.blockStatusToReferrer = function(jsBlockStatusToReferrer) {
            $rootScope.loading = true;
            application.toggleStatus($scope.details.EId, $scope.details.companyEId, !$scope.details.jsBlockStatusToReferrer, function(res) {
                if (res.data && res.data.msgInfo !== 200) {
                    //block / unblock status sharing to Referrer(s)
                    if(jsBlockStatusToReferrer){
                        $scope.details.jsBlockStatusToReferrer = true;
                    }else{
                        $scope.details.jsBlockStatusToReferrer = false;
                    }
                }
                $rootScope.loading = false;
            }, function() {
                $rootScope.loading = false;
            });
        };

        var init = function() {
            $rootScope.loading = true;
            application.getDetails($routeParams.jobId).then(function(response) {
                var res = response.data;
                $rootScope.messageLength = res.messageLength;
                $scope.details = res.application;
                $scope.applicationStatus = res.applicationStatus;
                $scope.companyName = res.companyName;
                $scope.interviewMessages = res.interviewMessages;
                $scope.interviews = res.interviews;
                $scope.messages = res.application.messages;
                $scope.timezone = res.timezone;
                $scope.enableReferralStatusVisibility = res.enableReferralStatusVisibility;
                $scope.enableJobviteEsign = res.enableJobviteEsign;
                $scope.getConsent = res.getConsent;
                $scope.referred = res.referred;
                $scope.privacyPolicyURL = res.privacyPolicyURL;
                angular.forEach(res.interviewMessages, function(interviewMessage) {
                    angular.forEach(interviewMessage.forms, function(form){
                        $scope.InterviewForms.push(form);
                    });
                });
                if (angular.isDefined(res.enableReferralStatusVisibility) && res.enableReferralStatusVisibility
                    && angular.isDefined($scope.details.jsBlockStatusToReferrer) && $scope.details.jsBlockStatusToReferrer == null) {
                    $scope.details.jsBlockStatusToReferrer = false;
                }

                if (res.enableJobviteEsign){
                    var documentType = null;
                    $scope.documentViewer.document.status = res.nativeESignStatus;
                    if ( res.nativeESignStatus === DOCUMENT_STATUS_PENDING) {
                        documentType = DOCUMENT_TYPE_UNSIGNED;
                    } else if ( res.nativeESignStatus === DOCUMENT_STATUS_COMPLETED) {
                        documentType = DOCUMENT_TYPE_SIGNED;
                    }

                    if (documentType !== null) {
                        $scope.documentURL = application.getNativeEsignDocumentURL(res.application.EId, documentType);
                        application.getNativeEsignDocument(res.application.EId, documentType).then(function(response) {
                            $rootScope.loading = true;
                            var data = response.data;
                            if (response.status === 200 && data!== null && data.file !== null) {
                              $scope.documentViewer.document.type = documentType;
                              $scope.documentViewer.document.file = data.file;
                            }
                            const currentURL = window.location.href;
                            if(currentURL.includes('deepLink') && $scope.showOfferLetter()){
                                $scope.viewOfferLetter();
                            }
                            $rootScope.loading = false;
                            $scope.$apply();
                        }).catch(function(err) {
                           $rootScope.loading = false;
                           $log.error(err);
                           $scope.$apply();
                        });
                    }
                }
                $rootScope.loading = false;
                $scope.$apply();
            }).catch(function(err) {
                $rootScope.loading = false;
                $log.error(err);
                $scope.$apply();
            });
        };
    
        init();
    }
]);